export default __webpack_public_path__ + "static/media/M30Splus.8929d8b1.png";